import { typedFetch } from "@/lib/helpers";
import { RoomNotFoundError } from "../devices/errors/room-not-found.error";
import { API_METHODS } from "../shared";
import { getCopyAlertSchedulesToOwnerRoomsUrl } from "./api-url.constants";
import { ROOM_NOT_FOUND_ERROR } from "./errors";

export interface CopyAlertSchedulesResponse {
  updatedRooms: number;
}

export const copyAlertSchedulesToOwnerRooms = async (
  roomId: string
): Promise<CopyAlertSchedulesResponse> => {
  const result = await typedFetch(getCopyAlertSchedulesToOwnerRoomsUrl(roomId), {
    method: API_METHODS.POST,
  });

  if (result.ok) {
    const response = await result.json();
    return response;
  }

  const responseJson = await result.json();

  if ("error" in responseJson) {
    const message = Array.isArray(responseJson.message)
      ? responseJson.message[0]
      : responseJson.message;
    if (message === ROOM_NOT_FOUND_ERROR) throw new RoomNotFoundError();
    throw new Error(message);
  }

  throw new Error("Failed to copy alert schedules");
};
